// Client wrapper for /api/transmissions/log. The acting player_id is
// derived server-side from the session cookie — no body field.

const TRIP_ID_DEFAULT = 'juneau-2026';

export async function fetchTransmissionsLog({ tripId = TRIP_ID_DEFAULT, testMode = false } = {}) {
  const params = new URLSearchParams({ trip_id: tripId });
  if (testMode) params.set('test_mode', 'true');
  const res = await fetch(`/api/transmissions/log?${params}`, { credentials: 'include' });
  if (!res.ok) {
    let body;
    try {
      body = await res.json();
    } catch {
      body = { message: await res.text() };
    }
    const err = new Error(body.message || body.error || `transmissions log → ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
